import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { NavMap } from '../../constants/NavConsts';

class Metadata extends PureComponent {
  render() {
    let metadata = null;
    if (this.props.location && this.props.location.pathname) {
      const navMap = NavMap[this.props.location.pathname];
      if (navMap && navMap.metadata) {
        metadata = navMap.metadata;
      }
    }
    return (
      <Helmet 
        {...metadata}
      />
    )
  }
}

export default withRouter(Metadata);